import {
    type FieldMergeFunction,
    type FieldReadFunction,
    type KeyArgsFunction,
} from "@apollo/client/cache/inmemory/policies";
import { type MyLensesApiToken } from "../../../../../gql-generated/types";

interface TypePolicy {
    keyArgs?: KeyArgsFunction;
    read?: FieldReadFunction<MyLensesApiToken[], MyLensesApiToken[]>;
    merge?: FieldMergeFunction<MyLensesApiToken[], MyLensesApiToken[]>;
}

const apiTokensTypePolicy: TypePolicy = {
    merge(target = [], source) {
        if (target.length === 0) {
            return source;
        }
        return target;
    },
};

export const appInfoTypePolicy = {
    apiTokens: apiTokensTypePolicy,
};
